<template>
  <div class="pa-30 container">
    页面内容待定。。。
  </div>
</template>
<style lang="scss"  scoped>
.container{
    min-height: 1150px;
    // background: #ffffff;
    box-sizing: border-box;
    padding: 30px 40px;
}
</style>

<script>

// studycollect
export default {
  name: "null",
  data() {
    return {
    };
  },

  created() {
    // console.log("created----");
   
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0);
    // 判断是否从详情页面回来
    if (from.path == "/competition/winner/detail") {
      to.meta.isBack = true;
    } else {
      to.meta.isBack = false;
    }
    next();
  },

  // 其他页面进来时更新初始数据
  activated() {
    
  },
  computed: {
  },
  mounted() {
  },

  methods: {
  },
};
</script>
